import React, { useEffect } from 'react'
import Card from '../../Components/OEE/card.homepage'
import "./oee.css"
import { testFunc } from '../../Utils/constants'

const Homepage = () => {

    useEffect(() => {
        testFunc()
    }, [])


    return (
        <div className='oee-homepage'>
            <Card />
        </div>
    )
}

export default Homepage